import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';

export class RegLaboratorioItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RegLaboratorioItemViewModel[];
}

export class RegLaboratorioItemViewModel {
    public Id: number;
    public RazonSocial = '';
    public IdComunidadAutonomaDescripcion = '';
    public IdComunidadAutonoma: number;
    public IdProvinciaDescripcion = '';
    public IdProvincia: number;
    public IdMunicipioDescripcion = '';
    public IdMunicipio: number;
    public Activo = false;
    public Direccion = '';
    public CodigoPostal = '';
    public NombrePersonaContacto = '';
    public ApellidosPersonaContacto = '';
    public EmailPersonaContacto = '';
    public TelefonoPersonaContacto = '';
    public Observaciones = '';
}

export class FilterSearchingRegLaboratorioViewModel extends FilterSearchingBaseViewModel {
    public Id: number;
    public RazonSocial = '';
    public Direccion = '';
    public CodigoPostal = '';
    public IdComunidadAutonoma: number | null;
    public IdProvincia: number | null;
    public IdMunicipio: number | null;
    public NombrePersonaContacto = '';
    public ApellidosPersonaContacto = '';
    public EmailPersonaContacto = '';
    public TelefonoPersonaContacto = '';
    public Activo: number = EnumSiNoTodos.TODOS;
}

export class RegLaboratorioViewModel {
    public Id: number;
    public RazonSocial = '';
    public IdComunidadAutonoma: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public Direccion = '';
    public CodigoPostal = '';
    public NombrePersonaContacto = '';
    public ApellidosPersonaContacto = '';
    public EmailPersonaContacto = '';
    public TelefonoPersonaContacto = '';
    public FechaAlta: Date;
    public FechaBaja: Date | null;
    public Observaciones = '';
    public Activo = false;

    public TwRegTecnicoLaboratorioCollection: RegTecnicoLaboratorioViewModel[];
}

export class RegTecnicoLaboratorioViewModel {
    public IdUsuario: number;
    public NifUsuario = '';
    public NombreUsuario = '';
    public ApellidosUsuario = '';
    public IdRegLaboratorio: number;
    public Activo: boolean;
    public Telefono = '';
    public FechaCreacion: Date;
    public FechaAlta: Date;
    public FechaBaja: Date | null;
}
